import { Button, Dialog, DialogActions, DialogContent, MenuItem, MenuList, Popover, TextField, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React, { useState, useEffect, useMemo, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import { setFilteredHistory, setSelectedSymbol } from '../../../store/Slices/historySlice';
import { IoTimerOutline } from "react-icons/io5";
import CheckIcon from "@mui/icons-material/Check"
import { MdOutlineCurrencyExchange } from "react-icons/md";
import { fetchAccountHistory } from '../../../store/thunks/orders';

export default function HistoryFilter() {
    const [filterPeriod, setFilterPeriod] = useState("today");
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [customDateRange, setCustomDateRange] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const selectedSymbol = useSelector((state) => state.history.setSelectedSymbol)
    const selectedTabType = useSelector((state) => state.history.selectedTabType)
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const [showFilter, setShowFilter] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const [uniqueSymbols, setUniqueSymbols] = useState([]);
    const { accountId: accountID } = useSelector(state => state.accountSummary)

    const handleOpenFilterMenu = (event) => {
        setAnchorEl2(event.currentTarget);
    };

    const handleCloseFilterMenu = () => {
        setAnchorEl2(null);
    };
    const handleSelectSymbol = (symbol) => {
        dispatch(setSelectedSymbol(symbol === "All" ? "" : symbol));
        setAnchorEl2(null);
    };
    const handleOpenMenu = (event) => {
        setAnchorEl(event.currentTarget);
        setShowFilter(prev => !prev)
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const accountHistory = useSelector((state) => state.orderPosition.accountHistory);
    // const creation = localStorage.getItem('creation');
    const { accountData } = useSelector((state) => state.accountSummary)
    const creation = accountData.creationDate


    useEffect(() => {
        const now = new Date();
        let from = now;
        let to = now;

        switch (filterPeriod) {
            case "today":
                from = dayjs().startOf('day');
                to = dayjs().endOf('day');
                break;
            case "lastWeek":
                from = dayjs().subtract(7, 'day').startOf('day');
                to = dayjs().endOf('day');
                break;
            case "lastMonth":
                from = dayjs().subtract(1, 'month').startOf('day');
                to = dayjs().endOf('day');
                break;
            case "Last3Month":
            case "Last3Months":
                from = dayjs().subtract(3, 'month').startOf('day');
                to = dayjs().endOf('day');
                break;
            case "Last6Month":
            case "Last6Months":
                from = dayjs().subtract(6, 'month').startOf('day');
                to = dayjs().endOf('day');
                break;
            case "LastYear":
                from = dayjs().subtract(1, 'year').startOf('day');
                to = dayjs().endOf('day');
                break;
            case "Custom":
                from = dayjs(fromDate).startOf('day');
                to = dayjs(toDate).endOf('day');
                break;
            default:
                from = creation ? dayjs(creation).startOf('day') : dayjs().startOf('day');
                to = dayjs().endOf('day');
        }
        if (accountID && from && to) {
            dispatch(fetchAccountHistory({
                accountId: accountID,
                from: from.format("YYYY-MM-DDTHH:mm:ss"),
                to: to.format("YYYY-MM-DDTHH:mm:ss")
            }));
        }
    }, [filterPeriod, fromDate, toDate, accountID, creation]);
    const getFilterRange = (period) => {
        const now = new Date();
        let _from = null;
        let _to = now.getTime();

        switch (period) {
            case "today":
                _from = new Date().setHours(0, 0, 0, 0);
                _to = new Date().setHours(23, 59, 59, 999);
                break;
            case "lastWeek":
                _from = dayjs().subtract(7, 'day').startOf('day').valueOf();
                break;
            case "lastMonth":
                _from = dayjs().subtract(1, 'month').startOf('day').valueOf();
                break;
            case "Last3Month":
            case "Last3Months":
                _from = dayjs().subtract(3, 'month').startOf('day').valueOf();
                break;
            case "Last6Month":
            case "Last6Months":
                _from = dayjs().subtract(6, 'month').startOf('day').valueOf();
                break;
            case "LastYear":
                _from = dayjs().subtract(1, 'year').startOf('day').valueOf();
                break;
            case "Custom":
                // _from = fromDate ? new Date(fromDate).getTime() : null;
                // _to = toDate ? new Date(toDate).getTime() : _to;
                _from = fromDate ? dayjs(fromDate).startOf('day').valueOf() : null;
                _to = toDate ? dayjs(toDate).endOf('day').valueOf() : _to;
                break;
            default:
                _from = creation ? new Date(creation).getTime() : null;
        }

        return { _from, _to };
    };
    const filteredHistory = useMemo(() => {
        if (!Array.isArray(accountHistory)) return [];

        const typeMap = {
            1: "Deposit",
            2: "Adjustment",
            3: "Credit In",
            4: "Withdrawal",
            5: "Credit Out",
        };
        return accountHistory.filter(row => {
            const matchesType =
                (selectedTabType === "Trades" && [10, 12].includes(row.type)) ||
                (selectedTabType === "Orders" && ![1, 2, 3, 4, 5, 10, 12].includes(row.type)) ||
                (selectedTabType === "Transaction" && [1, 2, 3, 4, 5].includes(row.type));

            const matchesSymbol = selectedSymbol
                ? (row.symbolData?.name || row.symbolName || "").trim().toLowerCase() === selectedSymbol.trim().toLowerCase()
                : true;

            const matchesSearch = !searchQuery ||
                Object.entries(row).some(([key, value]) => {
                    if (key === 'type') {
                        const label = typeMap[value];
                        return label?.toLowerCase().includes(searchQuery.toLowerCase());
                    }
                    return value?.toString().toLowerCase().includes(searchQuery.toLowerCase());
                });

            return matchesType && matchesSymbol && matchesSearch;
        });
    }, [accountHistory, selectedTabType, selectedSymbol, searchQuery]);

    const historyByDate = useMemo(() => {
        if (!Array.isArray(accountHistory)) return [];

        const { _from, _to } = getFilterRange(filterPeriod);

        return accountHistory.filter(row => {
            const rowDate = new Date(row.dateTime).getTime();
            return (!_from || rowDate >= _from) && (!_to || rowDate <= _to);
        });
    }, [accountHistory, filterPeriod, fromDate, toDate, creation]);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setFilteredHistory(filteredHistory));
    }, [filteredHistory, dispatch]);

    const handleCustomRangeClick = () => {
        setFilterPeriod('Custom');
        setCustomDateRange(true);
        setOpenModal(true);
    };
    const periods = [
        { key: 'today', value: 'Today' },
        { key: 'lastWeek', value: 'Last Week' },
        { key: 'lastMonth', value: 'Last Month' },
        { key: 'Last3Month', value: 'Last 3 Month' },
        { key: 'Last6Month', value: 'Last 6 Month' },
        { key: 'allHistory', value: 'All History' }
    ];
    useEffect(() => {
        const symbolsForTab = historyByDate?.filter(row => {
            if (selectedTabType === "Trades") return [10, 12].includes(row.type);
            if (selectedTabType === "Orders") return ![1, 2, 3, 4, 5, 10, 12].includes(row.type);
            if (selectedTabType === "Transaction") return [1, 2, 3, 4, 5].includes(row.type);
            return false;
        });

        const symbols = [
            ...new Set(
                symbolsForTab.map(row =>
                    (row.symbolData?.name || row.symbolName)?.trim()
                )
            ),
        ].filter(Boolean);

        setUniqueSymbols(symbols);
    }, [historyByDate, selectedTabType]);

    return (
        <>
            <Tooltip title={t('filter')}><IoTimerOutline onClick={handleOpenMenu} style={{ cursor: 'pointer', fontSize: 20, color: 'white' }} /></Tooltip>
            {showFilter && (
                <Popover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleCloseMenu} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                    <div style={{ backgroundColor: darkMode ? "#262f3f" : "", color: darkMode ? "var(--lightText)" : '#var(--darkText)' }}>

                        {periods.map((period) => (
                            <MenuItem key={period.key} onClick={() => { setFilterPeriod(period.key); setAnchorEl(null) }} sx={{ fontSize: 13.5 }}>{t(`${period.key}`)}  {filterPeriod === period.key && (<CheckIcon sx={{ fontSize: 18, color: "#4597ff" }} />)}</MenuItem>
                        ))}
                        <MenuItem key="Custom Range" onClick={handleCustomRangeClick} sx={{ fontSize: 13.5 }}>{t('customRange')}</MenuItem>

                        <Dialog open={openModal} onClose={() => setOpenModal(false)} >
                            <DialogContent sx={{ backgroundColor: darkMode ? "#262f3f" : "", }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div style={{ display: 'flex', flexDirection: "column", gap: '16px', color: darkMode ? 'var(--lightText)' : '#var(--darkText)' }}>
                                        <DatePicker label={t('fromDate')} value={dayjs(fromDate)} onChange={(newValue) => setFromDate(newValue)} renderInput={(params) => <TextField {...params} />} />
                                        <DatePicker label={t('toDate')} value={dayjs(toDate)} onChange={(newValue) => setToDate(newValue)} renderInput={(params) => <TextField {...params} />} />
                                    </div>
                                </LocalizationProvider>
                            </DialogContent>
                            <DialogActions sx={{ backgroundColor: darkMode ? "#262f3f" : "", }}>
                                <Button onClick={() => setOpenModal(false)} color="primary" variant='outlined'>{t('cancel')}</Button>
                            </DialogActions>
                        </Dialog>

                    </div>
                </Popover>
            )}
            <Tooltip title={t('filterbySymbol')}><MdOutlineCurrencyExchange onClick={handleOpenFilterMenu} style={{ cursor: 'pointer', fontSize: 18, color: 'white' }} /></Tooltip>
            <Popover open={Boolean(anchorEl2)} anchorEl={anchorEl2} onClose={handleCloseFilterMenu} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                <MenuList sx={{ backgroundColor: darkMode ? '#202933' : '#fff' }}>
                    <MenuList sx={{ backgroundColor: darkMode ? "#202933" : "#fff", }}>
                        {uniqueSymbols?.length > 0 && (
                            <MenuItem onClick={() => handleSelectSymbol("All")} sx={{ fontSize: 13.5, }}>{t('allSymbols')}</MenuItem>
                        )}
                        {uniqueSymbols.length > 0 ? uniqueSymbols.map((symbol, index) => (
                            <MenuItem key={index} onClick={() => handleSelectSymbol(symbol)} sx={{ fontSize: 13.5, display: "flex", justifyContent: "space-between" }}>{symbol}{selectedSymbol === symbol && <CheckIcon fontSize="small" sx={{ fontSize: 18, color: "#4597ff" }} />}</MenuItem>
                        )) : (<MenuItem disabled sx={{ fontSize: 13.5 }}>{t('NoSymbolsAvailable')}</MenuItem>)}
                    </MenuList>
                </MenuList>
            </Popover>
        </>
    )
}
